import axios from 'axios';
import ServerProperties from '../../config/server.js';
import url from '../../config/url.js';


export default {
  Search: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      ServerProperties.ATM_CLOUD.API + url[params.data.Path] + '?&page=1&search=' + params.data.Query + (params.data.Extra ? '&' + params.data.Extra : '')
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {            
      params.onfailed(params, error)
    });
  }
}


// WEBPACK FOOTER //
// ./src/App/component/helper/model.js